<template>
<b-card-actions action-collapse title="Property Pin Tag">
  <validation-observer ref="simpleRules">
    <b-form @submit.prevent="validationForm">
      <b-row>
        <b-col
          cols="12"
          class="mb-2"
        >
          <div class="border rounded p-2">
            <h4 class="mb-1">
              Icon
            </h4>
            <b-media
              no-body
              vertical-align="center"
              class="flex-column flex-md-row"
            >
              <b-media-aside>
                <b-img
                  id="tag-icon-preview"
                  ref="refPreviewEl"
                  :src="iconSrc"
                  height="80"
                  width="80"
                  class="rounded mr-2 mb-1 mb-md-0"
                />
              </b-media-aside>
              <b-media-body>
                <small class="text-muted">(Recommend Size : 64x64)</small>
                <b-card-text class="my-50">
                  <b-link id="tag-icon-text">
                    C:\fakepath\{{ input.userFile ? input.userFile.name : 'icon.png' }}
                  </b-link>
                </b-card-text>
                <div class="d-inline-block">
                  <b-form-file
                    ref="refInputEl"
                    v-model="input.userFile"
                    accept=".jpg, .png, .gif, .svg"
                    placeholder="Choose file"
                    @input="inputImageRenderer"
                  />
                </div>
              </b-media-body>
            </b-media>
          </div>
        </b-col>

        <b-col md="12">
          <b-tabs content-class="mt-1" v-if="languages.length > 0">
            <b-tab
              v-for="(lang, key) in languages"
              :key="'tab-' + key"
              :title="lang.name"
            >
                <b-form-group>
                  <label>Name</label>
                  <validation-provider
                    v-slot="{ errors }"
                    :rules="'required'"
                    :name="`name_${lang.code}`"
                  >
                    <b-form-input
                      v-model="input.name[lang.code]"
                      :placeholder="`Tag Name ${lang.code}`"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
            </b-tab>
          </b-tabs>
        </b-col>

        <b-col md="12">
          <b-form-group>
            <label>Active</label>
            <validation-provider
                    #default="{ errors }"
                rules="required"
                name="is_active"
                >
                <b-form-checkbox
                checked="true"
                class="custom-control-primary"
                v-model="input.is_active"
                switch
            />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-button variant="primary" type="submit" :disabled="isSubmitting">
            <b-spinner v-if="isSubmitting" small class="mr-50" />Submit
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</b-card-actions>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BFormCheckbox, BTabs, BTab, BSpinner,
  BMedia, BMediaAside, BMediaBody, BCardText, BImg, BFormFile, BLink,
} from 'bootstrap-vue'
import BCardActions from '../../../../@core/components/b-card-actions/BCardActions.vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ref } from '@vue/composition-api'
import router from '@/router'
import defaultTagIcon from '../defaultTagIcon'

export default {
  components: {
    BCardActions,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    BTabs,
    BTab,
    BSpinner,
    BMedia,
    BMediaAside,
    BMediaBody,
    BCardText,
    BImg,
    BFormFile,
    BLink,
  },
  data() {
    return {
      id: router.currentRoute.params.id,
      isSubmitting: false,
      userData: JSON.parse(localStorage.getItem('userData')),
      input: {
        name: {},
        is_active: true,
        icon: null,
        userFile: null,
      },
      languages: [],
    }
  },
  computed: {
    iconSrc() {
      return this.input.icon || defaultTagIcon
    },
  },
  created() {
    if(this.id != undefined){
      this.getData();
    }

    this.fetchLangData()
  },
  setup() {
    const refInputEl = ref(null)
    const refPreviewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      base64 => {
        refPreviewEl.value.src = base64
      }
    )

    return {
      refInputEl,
      refPreviewEl,
      inputImageRenderer,
    }
  },
  methods: {
    async getData(){
      const res = await axios.post('tags/v1/get', { id: this.id });
      const tag = res && res.data && res.data.data ? res.data.data[0] : null;

      if(tag){
        this.input = tag;
        this.input.is_active = this.input.is_active === 1 ? true : false;
      }
    },
    async fetchLangData() {
      const response = await axios.post('languages/v1/get', {
        is_active: 1
      })
      this.languages = response.data.data
    },
    makeToast(variant = null,title,message) {
      this.$bvToast.toast(message, {
        title: title,
        variant,
        solid: true,
      })
    },
    validationForm() {
      if (this.isSubmitting) return
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const formData = new FormData();
          if(this.input.userFile) formData.append('iconFile', this.input.userFile)
          formData.append('name', JSON.stringify(this.input.name))
          formData.append('is_active', this.input.is_active ? 1 : 0)
          this.isSubmitting = true;

          if(this.id != undefined){
            formData.append('id', this.id)
            formData.append('updated_by', this.userData.id)
            axios.post('tags/v1/update', formData)
              .then(res => {
                if(!res.data.success){
                  this.makeToast('danger','Error 403',res.data.message);
                }else{
                  this.$router.push('/pin-tag/list', () => {
                    this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `Done`,
                          icon: 'CoffeeIcon',
                          variant: 'success',
                          text: `You have successfully updated.`,
                        },
                      })
                  });
                }
              }).catch(error => {
                this.makeToast('danger','Error 403',error.response && error.response.data && error.response.data.message);
              }).finally(() => {
                this.isSubmitting = false;
              })
          }else{
            formData.append('created_by', this.userData.id)
            axios.post('tags/v1/add', formData)
              .then(res => {
                if(!res.data.success){
                  this.makeToast('danger','Error 403',res.data.message);
                }else{
                  this.$router.push('/pin-tag/list', () => {
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-right',
                      props: {
                        title: `Done`,
                        icon: 'CoffeeIcon',
                        variant: 'success',
                        text: `You have successfully created.`,
                      },
                    })
                  });
                }
              }).catch(error => {
                this.makeToast('danger','Error 403',error.response && error.response.data && error.response.data.message);
              }).finally(() => {
                this.isSubmitting = false;
              })
          }
        }
      }).catch(error => {
        this.isSubmitting = false;
        this.makeToast('danger','Error',error.message || 'Something went wrong while submitting the form.');
      })
    },
  },
}
</script>
